import { keyframes } from "@mui/material/styles";

const wiggle = keyframes`
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-15deg); }
  50% { transform: rotate(10deg); }
  75% { transform: rotate(-5deg); }
`;


const aiChatToolbarStyles = {
  bell: {
    color: "primary.contrastText",
    animation: `${wiggle} .5s ease-in-out`,
  },
};

export default aiChatToolbarStyles;
